/**
 * @file contactInfoBanner.component.tsx
 * @path apps/website/src/components/contact/contactInfoBanner.component.tsx
 * @description UI component
 */

import { siteMetadata } from "@/config";
import { cn, formatPhone } from "@sirbastians/utils";
import { EnvelopeAtFill, GeoAltFill, PhoneFill } from "react-bootstrap-icons";

export const ContactInfoBanner = ({ className }: { className?: string }) => (
  <div className={cn("grid grid-cols-1 gap-8 w-full", className)}>
    {/* Email */}
    <div className="flex flex-col items-center text-center group p-6 rounded-2xl bg-card border border-border">
      <div className="flex-shrink-0 h-16 w-16 flex items-center justify-center rounded-full bg-secondary neuro-well text-accent mb-4 transition-transform duration-300 group-hover:scale-110">
        <EnvelopeAtFill className="h-7 w-7" />
      </div>
      <h4 className="text-[10px] font-montserrat uppercase tracking-[0.2em] text-muted-foreground mb-2">
        Email Us
      </h4>
      <a
        href={`${siteMetadata.email}`}
        className="text-base font-open-sans font-semibold text-foreground hover:text-accent transition-colors break-words"
      >
        {siteMetadata.email}
      </a>
    </div>

    {/* Phone */}
    <div className="flex flex-col items-center text-center group p-6 rounded-2xl bg-card border border-border">
      <div className="flex-shrink-0 h-16 w-16 flex items-center justify-center rounded-full bg-secondary neuro-well text-accent mb-4 transition-transform duration-300 group-hover:scale-110">
        <PhoneFill className="h-7 w-7" />
      </div>
      <h4 className="text-[10px] font-montserrat uppercase tracking-[0.2em] text-muted-foreground mb-2">
        Call Us
      </h4>
      <a
        href={`${siteMetadata.phone}`}
        className="text-base font-open-sans font-semibold text-foreground hover:text-accent transition-colors"
      >
        {formatPhone(siteMetadata.phone)}
      </a>
    </div>

    {/* Location */}
    <div className="flex flex-col items-center text-center group p-6 rounded-2xl bg-card border border-border">
      <div className="flex-shrink-0 h-16 w-16 flex items-center justify-center rounded-full bg-secondary neuro-well text-accent mb-4 transition-transform duration-300 group-hover:scale-110">
        <GeoAltFill className="h-7 w-7" />
      </div>
      <h4 className="text-[10px] font-montserrat uppercase tracking-[0.2em] text-muted-foreground mb-2">
        Location
      </h4>
      <p className="text-base font-open-sans font-semibold text-foreground">
        Cape Town, South Africa
      </p>
    </div>
  </div>
);
